import { render, staticRenderFns } from "./BlockHeading.vue?vue&type=template&id=674bea28&"
import script from "./BlockHeading.vue?vue&type=script&lang=js&"
export * from "./BlockHeading.vue?vue&type=script&lang=js&"
import style0 from "./BlockHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports